import { render, staticRenderFns } from "./EnrollmentDialog.vue?vue&type=template&id=50a88c13&scoped=true"
import script from "./EnrollmentDialog.vue?vue&type=script&lang=js"
export * from "./EnrollmentDialog.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentDialog.vue?vue&type=style&index=0&id=50a88c13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a88c13",
  null
  
)

export default component.exports